// extracted by mini-css-extract-plugin
export default {"productCarousel":"Eca-z","itemsContainer":"Fca-z"};